import Styles from './EditAccess.module.scss'
import { ShareSheetScreen, useShareSheetContext } from '../ShareSheetV2'
import { InviteUsers } from 'components/ShareSheet/InviteUsers'
import { Accesses } from 'components/ShareSheet/Accesses'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { InviteCollaborators } from 'components/ShareSheet/InviteCollaborators'
import { Header } from '../Header/Header'
import { Heading } from 'blaze-ui/Heading/Heading'

export const EditAccess = ({ title }: { title?: string }) => {
  const { setScreen, file } = useShareSheetContext()
  const { recipients, setShareSheet } = useShareSheetV2(file)

  const onBack = () => (recipients.length > 0 ? setShareSheet({ recipients: [] }) : setScreen(ShareSheetScreen.Default))

  if (recipients.length > 0) {
    return <InviteCollaborators file={file} />
  }

  return (
    <div className={Styles.container}>
      <Header onBack={onBack}>
        <Heading level={3}>{title || 'Edit Access'}</Heading>
      </Header>
      <div className={Styles.body}>
        <InviteUsers file={file} />
        <Accesses file={file} />
      </div>
    </div>
  )
}
